export enum TagTypeEnum {
  Competence = 'Competence',
  Role = 'Role',
  Location = 'Location',
}
